/**
 * config/pollingIntervals.js
 *
 * Constantes centralisées pour les intervalles de polling.
 *
 * OBJECTIF : réduire la charge serveur tout en gardant une bonne UX.
 *
 * CATÉGORIES :
 * - CRITICAL (1-5s) : pages où la fraîcheur de la donnée est vitale
 *   ex : Sécurité (entrées/sorties visiteurs en temps réel)
 * - HIGH (5-10s) : pages TV/wall display, tracking GPS live
 * - NORMAL (15-30s) : listes standards, notifications
 * - LOW (60s+) : pages rarement consultées, données qui changent peu
 *
 * RÈGLE DE POUCHE :
 * Plus la donnée est critique pour la sécurité/ops → plus court intervalle
 * Plus la page risque d'être laissée ouverte longtemps → plus long intervalle
 */

module.exports = {
  // Pages de sécurité : entrées/sorties visiteurs/agents/piétons
  // Laisser court car un visiteur qui attend ne peut pas patienter 30s
  SECURITY: 5000,

  // Notifications globales (cloche en topbar)
  // Peuvent attendre 15s sans frustration utilisateur
  NOTIFICATIONS: 15000,

  // Mode TV (kiosque affichage mural)
  // 10s est un bon compromis fraîcheur vs charge serveur
  MODE_TV: 10000,

  // Tracking GPS en direct d'un véhicule spécifique (carte)
  // 3s pour garder la fluidité de l'animation
  GPS_TRACKING: 3000,

  // Monitoring Falcon GPS (positions flotte)
  // Falcon API a son propre cache, 5s est inutile → 30s
  FALCON_MONITORING: 30000,

  // Listes standards (AffectationDemande, BonSortiePerso, etc.)
  // Fraîcheur acceptable à 30s pour des listes d'administration
  LIST_STANDARD: 30000,

  // Pages de rapports/dashboards (calculs agrégés)
  // Données qui changent peu → 60s
  RAPPORTS: 60000,

  // Pages de suivi (taches, déclarations, etc.)
  // Données qui changent peu → 30s
  SUIVI: 30000,

  // Pages de contrôle technique (suivi réparation, audit)
  // Données qui changent peu → 30s
  CONTROLE: 30000,

  // Vérification automatique des records verrouillés (déclarations)
  // Pas besoin d'être fréquent → 5 min (inchangé)
  STALE_RECORDS_CHECK: 300000,

  // Mode TV Dashboard (page principale)
  // 10s comme les autres mode TV
  DASHBOARD_TV: 10000,
};
